export var MaintenanceRunStatus;
(function (MaintenanceRunStatus) {
    MaintenanceRunStatus["MAINTENANCE_RUN_STATUS_UNSPECIFIED"] = "MAINTENANCE_RUN_STATUS_UNSPECIFIED";
    MaintenanceRunStatus["MAINTENANCE_RUN_STATUS_PENDING"] = "PENDING";
    MaintenanceRunStatus["MAINTENANCE_RUN_STATUS_RUNNING"] = "RUNNING";
    MaintenanceRunStatus["MAINTENANCE_RUN_STATUS_SUCCESS"] = "SUCCESS";
    MaintenanceRunStatus["MAINTENANCE_RUN_STATUS_FAILED"] = "FAILED";
    MaintenanceRunStatus["MAINTENANCE_RUN_STATUS_CANCELLED"] = "CANCELLED";
})(MaintenanceRunStatus || (MaintenanceRunStatus = {}));
